import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchPagination, getConfig } from "./fetchConfig";
import { openModal } from "../redux/modal/modalSlice";
import { errorHandler } from "../commonFunctions/errorHandler";
import { LOCAL_SERVICE } from "../configuration/constantes";

export function baseThunk(name, url, type){
    return createAsyncThunk(name, async (params, thunkApi) => {
        const data = await baseRequest(params, thunkApi.dispatch, url, type )
        return data
      }
    )
}

export function getUrl(){
    return  window.getConfig("BACK_URL") + window.getConfig("ENDPOINT_URL");
  }

export const url = (window.getConfig("BACK_URL")? window.getConfig("BACK_URL") : window.location.protocol + "//" + window.location.hostname +  ":" + window.location.port )+ window.getConfig("ENDPOINT_URL");
    
export async function baseRequest(params, dispatch, url, type){
    const config = getConfig(type)
    let completeUrl = (window.getConfig("BACK_URL")? window.getConfig("BACK_URL") : window.location.protocol + "//" + window.location.hostname +  ":" + window.location.port)+ window.getConfig("ENDPOINT_URL") + url;
    if (params?.param) {completeUrl= completeUrl + "/" + params.param}
    if (params?.query) {completeUrl = completeUrl + params.query}
    if (params?.pagination) {completeUrl = completeUrl + fetchPagination(params.pagination)}  
    const response = await fetch(completeUrl, config(params?.body, params?.excludeContentType));
    const data = await response.text();
    let result = "";
    if (data) { result = await JSON.parse(data) }
    if (!response.ok) {
      let message = result;
      const error = {code: response.status, message: message} 
      dispatch(openModal(errorHandler(error)))
          throw error
    };

    return result
}



